/*eslint-disable*/
import CircularLoading from "../../../components/CircularLoading";
import { Select } from "@material-ui/core";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Input,
  FormText,
  Row,
  Col,
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import AlertDialog from "../../../components/AlertDialog";
import { FirebaseContext } from "common";
// import Input from "components/Input/Input";
import MenuItem from "@material-ui/core/MenuItem";
function PatientSocial({ props, route }) {
  /////////////////////////////////////////////////////////
  //REdux
  const { api } = useContext(FirebaseContext);
  const { editMedicalHistory } = api;
  const dispatch = useDispatch();
  const medical = useSelector(
    (state) => state.medicalRecords.medicalHistoryRecords
  );
    const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const [medicalData, setMedicalData] = useState(medical);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  /////////////////////////////////////////////////////////

  ///////////////////////////////////////////////////////////////
  //useEffect 1
  useEffect(() => {
    if (auth.info && auth.info.profile) {
      setMedicalData(medical);
    }
  }, [medical]);
  const OnSave = () => {
    let payload = {
      Medical_Information: {
        ...medical,
        LifeStyle_History: {
          ...medicalData.LifeStyle_History,
          SocialHistory: medicalData?.LifeStyle_History?.SocialHistory
            ? medicalData?.LifeStyle_History?.SocialHistory
            : null,
        },
      },
    };
    console.log("this is social payload:", payload);
    dispatch(editMedicalHistory(payload, "Add medical history"));
    setCommonAlert({ open: true, msg: "Your Social History Has Been Saved" });
    navigate(-1);
  };

  const updateSocialHistoryField = (field, value) => {
  setMedicalData((prev) => ({
    ...prev,
    LifeStyle_History: {
      ...prev.LifeStyle_History,
      SocialHistory: {
        ...prev.LifeStyle_History?.SocialHistory,
        [field]: value,
      },
    },
  }));
};


  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };
  return auth.loading ? (
    <CircularLoading />
  ) : (
    <>
     <div className="content">
  <div className="medicalhistory-form">
    <Row>
      <Col md="12">
        <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
          {commonAlert.msg}
        </AlertDialog>
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Life and Health History</CardTitle>
          </CardHeader>
          <CardBody>
            {/* Top Row */}
            <Row>
              <Col md="4">
                <FormText color="default" tag="span">
                  Occupation
                </FormText>
              </Col>
              <Col md="4">
                <FormText color="default" tag="span">
                  How many children do you have:
                </FormText>
              </Col>
              <Col md="4">
                <FormText color="default" tag="span">
                  Select Your Marital Status:
                </FormText>
              </Col>
            </Row>

            <Row>
              <Col md="4">
                <Input
                  label={"Your Occupation"}
                  value={
                    medicalData?.LifeStyle_History?.SocialHistory?.occupation || ""
                  }
                  onChange={(e) =>
                    updateSocialHistoryField("occupation", e.target.value)
                  }
                />
              </Col>

              <Col md="4">
                <Input
                  label={"Number of Dependents"}
                  value={
                    medicalData?.LifeStyle_History?.SocialHistory?.children || ""
                  }
                  onChange={(e) =>
                    updateSocialHistoryField("children", e.target.value)
                  }
                />
              </Col>

              <Col md="4">
                <Select
                  fullWidth
                  onChange={(e) =>
                    updateSocialHistoryField("maritalstatus", e.target.value)
                  }
                  value={
                    medicalData?.LifeStyle_History?.SocialHistory?.maritalstatus || ""
                  }
                >
                  <MenuItem value="Married">Married</MenuItem>
                  <MenuItem value="Single">Single</MenuItem>
                  <MenuItem value="Divorced">Divorced</MenuItem>
                  <MenuItem value="Widowed">Widowed</MenuItem>
                </Select>
              </Col>
            </Row>

            {/* General Diet / Sexual Orientation / Exercise */}
            <Row>
              <Col md="4">
                <FormText color="default" tag="span">
                  Your General Diet:
                </FormText>
              </Col>
              <Col md="4">
                <FormText color="default" tag="span">
                  Select Your Sexual Orientation
                </FormText>
              </Col>
              <Col md="4">
                <FormText color="default" tag="span">
                  How often/Hard you Exercise?
                </FormText>
              </Col>
            </Row>

            <Row>
              <Col md="4">
                <Select
                  fullWidth
                  onChange={(e) =>
                    updateSocialHistoryField("diet", e.target.value)
                  }
                  value={medicalData?.LifeStyle_History?.SocialHistory?.diet || ""}
                >
                  <MenuItem value="Balanced">Balanced</MenuItem>
                  <MenuItem value="Vegetarian">Vegetarian</MenuItem>
                  <MenuItem value="Vegan">Vegan</MenuItem>
                </Select>
              </Col>

              <Col md="4">
                <Select
                  fullWidth
                  onChange={(e) => {
                    const value = e.target.value;
                    updateSocialHistoryField("sexualorientation", value);
                    if (value !== "Other") {
                      updateSocialHistoryField("sexualorientation_other", "");
                    }
                  }}
                  value={
                    medicalData?.LifeStyle_History?.SocialHistory?.sexualorientation || ""
                  }
                >
                  <MenuItem value="Heterosexual">Heterosexual</MenuItem>
                  <MenuItem value="Homosexual">Homosexual</MenuItem>
                  <MenuItem value="Bisexual">Bisexual</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </Select>

                {medicalData?.LifeStyle_History?.SocialHistory?.sexualorientation ===
                  "Other" && (
                  <Input
                    label="Please specify"
                    value={
                      medicalData?.LifeStyle_History?.SocialHistory
                        ?.sexualorientation_other || ""
                    }
                    onChange={(e) =>
                      updateSocialHistoryField("sexualorientation_other", e.target.value)
                    }
                  />
                )}
              </Col>

              <Col md="4">
                <Select
                  fullWidth
                  onChange={(e) =>
                    updateSocialHistoryField("exercise", e.target.value)
                  }
                  value={
                    medicalData?.LifeStyle_History?.SocialHistory?.exercise || ""
                  }
                >
                  <MenuItem value="Sedentary">Sedentary</MenuItem>
                  <MenuItem value="Moderately">Moderately</MenuItem>
                  <MenuItem value="Vigorous">Vigorous</MenuItem>
                  <MenuItem value="Not Specified">Not Specified</MenuItem>
                </Select>
              </Col>
            </Row>

            {/* Alcohol / Smoking / Stress */}
            <Row>
              <Col md="4">
                <FormGroup tag="fieldset">
                  <FormText>Do you drink Alcohol?</FormText>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="radio"
                        name="alcohol"
                        checked={
                          medicalData?.LifeStyle_History?.SocialHistory
                            ?.alcoholconsumption === true
                        }
                        onChange={() =>
                          updateSocialHistoryField("alcoholconsumption", true)
                        }
                      />{" "}
                      Yes
                    </Label>
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="radio"
                        name="alcohol"
                        checked={
                          medicalData?.LifeStyle_History?.SocialHistory
                            ?.alcoholconsumption === false
                        }
                        onChange={() =>
                          updateSocialHistoryField("alcoholconsumption", false)
                        }
                      />{" "}
                      No
                    </Label>
                  </FormGroup>

                  {medicalData?.LifeStyle_History?.SocialHistory?.alcoholconsumption ===
                    true && (
                    <Input
                      label="Units per week"
                      value={
                        medicalData?.LifeStyle_History?.SocialHistory?.alcohol_units || ""
                      }
                      onChange={(e) =>
                        updateSocialHistoryField("alcohol_units", e.target.value)
                      }
                    />
                  )}
                </FormGroup>
              </Col>

              <Col md="4">
                <FormGroup tag="fieldset">
                  <FormText>Do you Smoke?</FormText>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="radio"
                        name="smoking"
                        checked={
                          medicalData?.LifeStyle_History?.SocialHistory?.smoking === true
                        }
                        onChange={() =>
                          updateSocialHistoryField("smoking", true)
                        }
                      />{" "}
                      Yes
                    </Label>
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="radio"
                        name="smoking"
                        checked={
                          medicalData?.LifeStyle_History?.SocialHistory?.smoking ===
                          false
                        }
                        onChange={() =>
                          updateSocialHistoryField("smoking", false)
                        }
                      />{" "}
                      No
                    </Label>
                  </FormGroup>
                </FormGroup>
              </Col>

              <Col md="4">
                <FormText>Select Your Stress Factor</FormText>
                <Select
                  fullWidth
                  onChange={(e) =>
                    updateSocialHistoryField("stressfactor", e.target.value)
                  }
                  value={
                    medicalData?.LifeStyle_History?.SocialHistory?.stressfactor || ""
                  }
                >
                  <MenuItem value="Low">Low</MenuItem>
                  <MenuItem value="Medium">Medium</MenuItem>
                  <MenuItem value="High">High</MenuItem>
                </Select>
              </Col>
            </Row>

            {/* Language & Substance Abuse */}
            <Row>
              <Col md="4">
                <FormText color="default" tag="span">
                  Home Language
                </FormText>
                <Input
                  label={"Home Language"}
                  value={
                    medicalData?.LifeStyle_History?.SocialHistory?.language || ""
                  }
                  onChange={(e) =>
                    updateSocialHistoryField("language", e.target.value)
                  }
                />
              </Col>

                      <Col md="4">
                        <FormGroup tag="fieldset">
                          <FormText>Substance Abuse</FormText>

                          <FormGroup check>
                            <Label check>
                              <Input
                                type="radio"
                                name="substanceabuse"
                                checked={
                                  medicalData?.LifeStyle_History?.SocialHistory?.substanceabuse === true
                                }
                                onChange={() =>
                                  updateSocialHistoryField("substanceabuse", true)
                                }
                              />{" "}
                              Yes
                            </Label>
                          </FormGroup>

                          <FormGroup check>
                            <Label check>
                              <Input
                                type="radio"
                                name="substanceabuse"
                                checked={
                                  medicalData?.LifeStyle_History?.SocialHistory?.substanceabuse === false
                                }
                                onChange={() =>
                                  updateSocialHistoryField("substanceabuse", false)
                                }
                              />{" "}
                              No
                            </Label>
                          </FormGroup>

                          {medicalData?.LifeStyle_History?.SocialHistory?.substanceabuse === true && (
                            <Input
                              label="Type of substance"
                              value={
                                medicalData?.LifeStyle_History?.SocialHistory?.substanceabuse_type || ""
                              }
                              onChange={(e) =>
                                updateSocialHistoryField("substanceabuse_type", e.target.value)
                              }
                            />
                          )}
                        </FormGroup>
                      </Col>


            </Row>

            {/* Save Button */}
            <Row>
              <Button variant="gradient" color="primary" onClick={OnSave}>
                UPDATE
              </Button>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
</div>

    </>
  );
}
export default PatientSocial;
